module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamelist-withe"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "gamelist"
  }, [_c('div', {
    staticClass: "gamelist-container"
  }, [_c('div', {
    staticClass: "user-content"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(this.usergame))]), _vm._v("，您好：\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t点击测试内容，进行您的脑健康测试吧！\n\t\t\t")])]), _vm._v(" "), _c('ul', _vm._l((_vm.gameListInfo), function(item, key, index) {
    return _c('li', {
      staticClass: "gameTitle-button",
      on: {
        "click": function($event) {
          _vm.imgIcon(item.gameUrl, item.id)
        }
      }
    }, [_c('dl', [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": "图片"
      }
    }), _vm._v(" "), (item.status == 1) ? _c('p', {
      staticClass: "game"
    }, [_c('b', [_vm._v("已测试")])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.brainCapacity))])])
  }))]), _vm._v(" "), (this.gameStatus == 1) ? _c('div', {
    staticClass: "gamelist-footer"
  }, [_c('p', [_vm._v("是否结束本次检测？如果确认结束，请点击确认按钮，完成检测，并可查看检测报告")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/viewreport",
      "tag": "span"
    }
  }, [_vm._v("确认")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67dada7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gamelist.vue
// module id = 760
// module chunks = 1